import { render, staticRenderFns } from "./IAvatar.vue?vue&type=template&id=b8d33764&"
import script from "./IAvatar.vue?vue&type=script&lang=js&"
export * from "./IAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports